import UtilSP from "SATPROF_UTILS/UtilSP.ts"; 
import passEvents from "SATPROF_UTILS/EventPassThrough.js";
import ExtendedDropin from "./main.ts";

// instantiate it
const dropin = new ExtendedDropin();

const windowBindings = { 
    UtilSP // if the variable is already named what you want it to be, you can use this syntax
}

// this code binds each of the above to the window for public access
const bindings = Object.keys(windowBindings);
console.log("In main-imports.js, bindings[] = ");
for(let i=0;i<bindings.length;i++){
    console.log(bindings[i])
    window[bindings[i]] = windowBindings[bindings[i]]; 
}